import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ButtonProps extends Omit<MuiButtonProps, 'sx'> {
  variant: 'contained' | 'outlined';
  width?: string;
  sx?: MuiButtonProps['sx'];
}

const StyledButton = styled(MuiButton)<{ width?: string }>(({ width }: { width?: string }) => ({
  height: '31px',
  borderRadius: '8px',
  textTransform: 'none',
  width: width || '100px',
  '&.MuiButton-contained': {
    backgroundColor: '#6E3FF3',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#5E2FE3',
    },
    '&:disabled': {
      backgroundColor: '#E0E0E0',
      color: '#666666',
      borderColor: '#E0E0E0',
    },
  },
  '&.MuiButton-outlined': {
    color: '#6E3FF3',
    borderColor: '#6E3FF3',
    '&:hover': {
      borderColor: '#6E3FF3',
      backgroundColor: 'rgba(110, 63, 243, 0.04)',
    },
    '&:disabled': {
      backgroundColor: '#E0E0E0',
      color: '#666666',
      borderColor: '#E0E0E0',
    },
  },
}));

const Button: React.FC<ButtonProps> = ({
  children,
  variant,
  width = 'auto',
  sx,
  ...props
}) => {
  return (
    <StyledButton
      variant={variant}
      width={width}
      sx={sx}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default Button; 